import React from 'react';
import { Background, Row } from 'acscp/components/common/row';
import style from 'acscp/components/common/pageHeaderRow.module.scss';
import { LoadingIndicator, LoadingIndicatorColour } from 'acscp/components/common/loadingIndicator';

interface PageHeaderRowProps {
    leftContent: React.ReactNode;
    showLoadingIndicator: boolean;
    rightContent: React.ReactNode;
    background?: Background;
}

class PageHeaderRow extends React.Component<PageHeaderRowProps, {}> {
    constructor(props: PageHeaderRowProps) {
        super(props);
    }

    render(): JSX.Element {
        return (
            <Row
                background={this.props.background !== undefined ? this.props.background : Background.LightestGrey}
                className={style.PageHeaderRow}
            >
                <div className={style.PageHeaderRowLeft}>
                    {this.props.leftContent}
                </div>
                {this.props.showLoadingIndicator &&
                <div className={style.PageHeaderRowLoading}>
                    <LoadingIndicator colour={LoadingIndicatorColour.Blue}/>
                </div>}
                <div className={style.PageHeaderRowRight}>
                    {this.props.rightContent}
                </div>
            </Row>
        );
    }
}

export { PageHeaderRow };
